import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { Button, Form, Input, Row, Col, Select, Typography, DatePicker, DateTimePicker, message, Modal, InputNumber, MainModal, useProTableOt, ProTableOt, Accordion, AccordionItem, AccordionTrigger, AccordionContent, UploadAudio, UploadImg, Spin, Checkbox, Switch, TimeSelector, formatDateToTimeZone, RangePicker, ImportButton, useCRUDController, ClassifyStructure, Card } from "../ui/ot";
import { useTranslation } from 'react-i18next';
import { useRecord } from './controller/record_controller';
import WeekCard from './components/week_card'

const  WeekOverview = ({
    keyPrefix = "shift_management.week_overview",
    propsForm,
    defaultValue = {},
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    customColumns = [],
    customDefaultColumns = [],
    customFormItems = () => { },
    extraActionRender = () => { },
    toolBarRender = (tools) => ([...tools]),
    propsUseRecord = useRecord,
    propsOnFinish = () => { },
    propsOnBefore = () => { },
    propsOnValuesChange = () => { },
    propsShowKeys = [
        { key: "id", name: "id", hidden: false, require: false },
        { key: "week_name", name: "week_name", hidden: false, require: false },
        { key: "week_code", name: "week_code", hidden: false, require: false },
    ],
    propsExtraParams = {},
    propsParsedBody = {},
    propsApiRoute = '/shift_management/api/week'
}) => {
    const { t } = useTranslation("translation", { keyPrefix });
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const defaultColumns = [
        {
            title: t('id'),
            dataIndex: 'id',
            key: 'id',
            align: "center",
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: t('week_name'),
            dataIndex: 'week_name',
            key: 'week_name',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search",
        },
        {
            title: t('week_code'),
            dataIndex: 'week_code',
            key: 'week_code',
            sorter: true,
            width: "8rem",
            canFilter: true,
            filterType: "search"
        }
    ];
    const columns = [
        ...customColumns,
        ...defaultColumns.filter(column => propsShowKeys.some(keyObj => keyObj.key === column.key && keyObj.hidden !== true)),
    ]
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])

    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form_] = Form.useForm();
    const form = propsForm || form_;
    const [axiosMode, setAxiosMode] = useState("get")
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.record_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.record_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = []
            let selectRow = []
            select_temp = [...selectedRowKeys]
            selectRow = [...selectedRowsInfo]

            if (selected) {
                select_temp.push(record.record_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.record_id)
                selectRow = selectRow.filter(row => row.record_id !== record.record_id)
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };

    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns
    })
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <ClassifyStructure
                        actionRef={actionRef}
                        customColumns={columns}
                        check={check}
                        setCheck={setCheck}
                        headerTitle={<></>}
                        apiRoute={propsApiRoute}
                        rowKey={'id'}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        scroll={{
                            x: "max-content"
                        }}
                        toolBarRender={(tools) => toolBarRender([
                            ...tools
                        ])}
                        rowSelection={{
                            type: null,
                            selectedRowKeys: selectedRowKeys,
                            setSelectedRowKeys: setSelectedRowKeys,
                            selectedRowsInfo: selectedRowsInfo,
                            setSelectedRowsInfo: setSelectedRowsInfo,
                            ...rowSelection,
                        }}
                        tableAlertRender={({ selectedRowKeys, selectedRows }) => {
                            return (
                                <div className="space-y-4">
                                    <span>
                                        已選 {selectedRowKeys.length} 項
                                        <Typography.P style={{ marginInlineStart: 8 }}
                                            onClick={onCleanSelected}>
                                            取消選擇
                                        </Typography.P>
                                    </span>
                                </div>
                            );
                        }}
                        defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                        defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                        axiosMode={axiosMode}
                        propsPatchOnFinish={({ axiosMode, status }) => {
                            if (status === "success") {
                                actionRef.current.reload()
                            } else {

                            }
                        }}
                        propsPost={false}
                        propsSort={false}
                        modalOpen={modalOpen}
                        setModalOpen={setModalOpen}
                        propsWidth={1000}
                        showMode='card'
                        cardModeSetting={{
                            columnsCount: 1,
                            singleRowHeight: '100vh',
                        }}
                        cardRender={(record) => {
                            return <>
                                <WeekCard
                                    propsApiRoute={propsApiRoute}
                                    keyPrefix={keyPrefix}
                                    record={record}
                                    propsExtraParams={propsExtraParams}
                                    propsParsedBody={propsParsedBody}
                                />
                            </>
                        }}
                        rowSelectionMode={null}
                    />
                </Col>
            </Row >
        </>
    );
};
export default WeekOverview;
